import getRuleError from "../utils/getRuleError";
import getRuleValue from "../utils/getRuleValue";
import {translate} from "../../../../i18n";
import getRequiredError from "../utils/getRequiredError";

let $value, $rules, $options, $allValues;

export default function (value, rules, options, allValues) {
    $value = value;
    $rules = rules;
    $options = options;
    $allValues = allValues;

    return checkRequired();
}

function checkRequired() {
    if ($value !== null) {
        return null;
    }

    return getRequiredError($rules, $options, $allValues);
}
